import React,{useEffect} from 'react';
import ReactGA from 'react-ga4';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import {
  Container,
  InfoNavbar,
  Loading,
  QuoteForm,
  QuoteFormTitle,
} from '../components/';
import { IQuoteForm, submitQuote } from '../store/Quote';
import { cleanRut, hashData } from '../helpers/utils';
import { env } from '../env';

interface IQuoteProps {
  quote: (payload: IQuoteForm) => void;
  submitting: boolean;
}

export function Quote(props: IQuoteProps) {
  const { quote, submitting } = props;

  useEffect(() => {
    if (env.REACT_APP_ENVIRONMENT === 'production' || env.REACT_APP_GTM_QA_ACTIVE === 'true') {
      ReactGA.send({
        hitType: 'pageview',
        location: 'salud.segurosfalabella.com/salud/visita',
        title: 'Seguro Salud Complementario',
      });

      // Funnel step viewed
      ReactGA.event("funnel_step_viewed", {
        'funnel_name': 'contratacion-seguro',
        'product_name': 'web-salud-complementario',
        'funnel_step_name': 'paso-visita'
      });
    }
  }, []);

  return (
    <Container>
      {!submitting && (
        <div className="relative">
          <div id="banner" className="w-100" />
          <div className="container">
            <div className="row">
              <QuoteFormTitle />
              <div className="col-12">
                <QuoteForm onSubmit={quote} />
              </div>
            </div>
          </div>
          <InfoNavbar />
        </div>
      )}
      {submitting && <Loading />}
    </Container>
  );
}

export const mapStateToProps = (state: any) => {
  const {
    Quote: { submitting },
  } = state;

  return { submitting };
};

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  quote: (payload: IQuoteForm) => {

    sessionStorage.setItem('userId',  `CL_RUT_${hashData(cleanRut(payload.documentId))}`);
    payload.phone = payload.phone.replace(/ /gi, '');
    dispatch(submitQuote(payload));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Quote);
